<template>
  <MainLayout section="ledgers">
    <b-alert v-bind:show="!valid_ledger_id" variant="danger" class="mb-0">
      Ledger ID not valid, must be >= {{config.GENESIS_LEDGER}}
    </b-alert>

    <b-container fluid id="ledgers-container" v-bind:class="$mq">
      <b-row no-gutters id="ledger_header" class="mb-2" v-bind:class="$mq">
        <b-col v-bind:cols="$mq == 'sm' ? 7 : 9">
          <b>Ledger:</b>
          <span id="ledger_id" v-if="!select_toggled" v-on:click="toggle_select()">
            {{ ledger_id }}
          </span>

          <span v-else>
            <b-form-input
              id="ledger_selector"
              v-bind:class="$mq"
              ref="ledger_selector"
              type="number"
              number
              min=config.GENESIS_LEDGER
              v-model="ledger_id"
              v-on:blur="toggle_select()" />
          </span>
        </b-col>

        <b-col v-bind:cols="$mq == 'sm' ? 5 : 3">
          <datetime v-model="timestamp"
                    type="datetime"
                    title="Ledger Timestamp"
                    placeholder="Ledger Timestamp"
                    value-zone="UTC"
                    zone="UTC"
                    v-bind:min-datetime="config.GENESIS_DATETIME"
                    format="yyyy-MM-dd HH:mm:ss"
                    v-on:close="timestamp_changed()"
                    v-bind:size="$mq == 'sm' ? '13' : null"
                    input-style="text-align: right; padding-right: 5px; font-size: 0.7em"/>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
            <div class="spinner_container" v-if="loading">
              <b-spinner />
            </div>
        </b-col>
      </b-row>

      <b-row v-show="have_ledger">
        <b-col  v-bind:cols="($mq == 'sm' || $mq == 'md') ? 12 : 6"
               v-bind:class="($mq == 'sm' || $mq == 'md') ? '' : 'pr-0'"
               id="ledger_wrapper">
          <div>
            <b-form-radio v-model="format"
                          value="formatted"
                          button
                          button-variant="light"
                          class="format_radio">
              Formatted
            </b-form-radio>

            <b-form-radio v-model="format"
                          value="raw"
                          button
                          button-variant="light"
                          class="format_radio">
              Raw
            </b-form-radio>
          </div>

          <div v-if="format=='formatted'" id="formatted_ledger">
            <RenderedLedger v-bind:ledger="ledger" />
          </div>

          <div v-else id="raw_ledger">
            <pre>{{JSON.stringify(ledger, null, 2)}}</pre>
          </div>
        </b-col>

        <b-col v-bind:cols="($mq == 'sm' || $mq == 'md') ?
                                (ledger_closed ? 6 : 12) :
                                (ledger_closed ? 3 : 6)"
               v-bind:class="($mq == 'sm' || $mq == 'md') ?
                            (ledger_closed ? 'pr-0' : '') :
                             (ledger_closed ? 'pr-0 pl-0' :
                                              'pl-0')"
               style="flex-grow: 1">
          <LedgerTxsByType v-bind:ledger="ledger"/>
        </b-col>

        <b-col v-if="ledger_closed"
               v-bind:cols="($mq == 'sm' || $mq == 'md') ? 6 : 3"
               class="pl-0" style="flex-grow: 1">
          <LedgerTxsByResult v-bind:ledger="ledger"/>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <LedgerAccounts v-bind:ledger="ledger" />
        </b-col>
      </b-row>
    </b-container>
  </MainLayout>
</template>

<script>
import MainLayout        from './components/MainLayout.vue'
import RenderedLedger    from './components/RenderedLedger.vue'
import LedgerTxsByType   from './components/LedgerTxsByType.vue'
import LedgerTxsByResult from './components/LedgerTxsByResult.vue'
import LedgerAccounts    from './components/LedgerAccounts.vue'

var CommandDispatcher = require('./mixins/command_dispatcher')
import config from './config'
import util from './util'

// TODO: renamed to Ledger, add "Ledgers" section (same nav section)
//       which range of ledgers can be selected

function get_ledger(vue, ledger){
  var cmd = {
    'command'      : 'ledger',
    'ledger_index' :  ledger,
    'transactions' : true,
    'expand'       : true
  };

  vue.loading = true;

  vue.sendCmd(cmd, function(ledger){
    vue.ledger_id = ledger.ledger["ledger_index"];
    vue.ledger = ledger;
    vue.loading = false;

    if(ledger.ledger["close_time"])
      vue.timestamp = new Date(util.ledger_time_to_unix(ledger.ledger["close_time"])).toISOString();
    else
      vue.timestamp = null;
  });
}

function get_ledger_v2(vue, identifier){
  vue.loading = true;

  vue.$http.get(config.RIPPLE_DATAV2_URI + "ledgers/" + identifier + "?expand=true")
           .then(function(response){
             var ledger = response["body"];
             Object.freeze(ledger);
             vue.$router.push("/ledger/" + ledger.ledger["ledger_index"]);
           });
}

function get_current_ledger(vue){
  vue.sendCmd({command : 'ledger_current'}, function(ledger){
    vue.$router.push("/ledger/" + ledger["ledger_current_index"]);
  });
}

// copy url-set params to store
function set_params(vue){
  vue.ledger_id = vue.iledger_id;
}

export default {
  name: 'Ledgers',

  mixins : [CommandDispatcher],

  components: {
    MainLayout,
    RenderedLedger,
    LedgerTxsByType,
    LedgerTxsByResult,
    LedgerAccounts
  },

  props : {
    iledger_id : String
  },

  data : function(){
    return {
              config : config,
             loading : true,
           timestamp : '',
      select_toggled : false,
              format : 'formatted'
    };
  },

  computed : {
    ledger : {
      get : function(){
        return this.$store.state.ledger;
      },

      set : function(ledger){
        this.$store.commit('set_ledger', ledger);
      }
    },

    have_ledger : function(){
      return !!this.ledger.ledger_index;
    },

    ledger_closed : function(){
      return this.ledger.closed;
    },

    ledger_id : {
      get : function(){
        return this.$store.state.ledger_id || null;
      },

      set : function(i){
        this.$store.commit('set_ledger_id', parseInt(i));
      }
    },

    valid_ledger_id : function(){
      return this.ledger_id == null || this.ledger_id >= config.GENESIS_LEDGER;
    }
  },

  watch : {
   '$route' : function(){
     set_params(this);

     // TODO: only if different
     get_ledger(this, this.ledger_id);
   }
  },

  methods : {
    toggle_select : function(){
      this.select_toggled = !this.select_toggled;
      
      if(this.select_toggled)
        // XXX: need to run on next tick as ledger_selecter
        //      input will not be available yet
        this.$nextTick(function(){this.$refs.ledger_selector.$el.focus()});

      else if(this.valid_ledger_id)
        this.$router.push("/ledger/" + this.ledger_id);
    },

    timestamp_changed : function(){
      get_ledger_v2(this, this.timestamp);
    }
  },

  created : function(){
    set_params(this);

    this.$store.commit('clear_ledger');

    this.$store.commit('on_open_socket', function(){
      var specified = this.ledger_id;

      if(specified)
        get_ledger(this, specified);
      else
        get_current_ledger(this);
    }.bind(this));
  }
}
</script>

<style scoped>
#ledgers-container{
  flex-grow: 1;
  padding: 25px;
  margin: 0;
  background: #eef1f6;
}

#ledgers-container.sm{
  margin-top: 5px;
}

#ledger_header{
  background-color: white;
  padding: 10px;
  border: 1px solid #cccccc;
  font-size: 1.3rem;
}

#ledger_header.sm{
  font-size: 1.2em;
}

#ledger_id {
  font-weight: bold;
  color: blue;
  cursor: pointer;
}

#ledger_selector{
  display: inline-block;
  width: unset;
  margin-left: 10px;
}

#ledger_selector.sm{
  margin: 0;
  margin-left: 5px;
  width: 50%;
}

.vdatetime{
  float: right;
}

#ledger_wrapper{
  display: flex;
  flex-direction: column;
}

.format_radio{
  width: 50%;
}

.format_radio >>> .btn{
  width: 100%;
  border-radius: 0;
}

#formatted_ledger{
  overflow: hidden;
  flex-grow: 1;
}

#raw_ledger{
  overflow: auto;
  background-color: white;
  padding: 15px;
}
</style>
